<template>
    <div class="table-holder">
        <table class="table">
            <thead class="thead-dark">
                <tr>
                    <th>No</th>
                    <th>Sender Title</th>
                    <th>Sender Date</th>
                    <th>Receiver Title</th>
                    <th>Update Date</th>
                    <th>Status</th>
                    <th>Created Date</th>
                </tr>
            </thead>
            <tbody>
                <tr 
                    v-for="(data,index) in response"
                    :key="data.id">
                        <td>
                            <p>
                                {{ index +1  }}
                            </p>
                        </td>
                        <td>
                            <p>
                                <a :href="`/campaigns/${data.sender.campaign}`" target="_blank">
                                    {{ data.sender.title }}
                                </a>
                            </p>
                        </td>
                        <td>
                            <p>
                                {{ data.sender.update_date.seconds | formatDate }}
                            </p>
                        </td>
                        <td>
                            <p>
                                <a :href="`/campaigns/${data.receiver.campaign}`" target="_blank">
                                    {{ data.receiver.title}}
                                </a>
                            </p>
                        </td>
                        <td>
                            <p>
                                {{ data.receiver.update_date.seconds | formatDate }}
                            </p>
                        </td>
                        <td>
                            <p>
                                {{ data.status }}
                            </p>
                        </td>
                        <td>
                            <p>
                                {{ data.created_date.seconds | formatDate }}
                            </p>
                        </td>
                </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
import { mapState } from 'vuex'
import moment from 'moment'
import { db, ADMINS } from '../../../firebase'
export default {
    name: 'Index',
    data() {
        return {
            response: {},
        }
    },
    computed: {
        ...mapState([
            'user'
        ])
    },
    mounted: function() {
        if(ADMINS.includes(this.user.uid)) {
            this.getData()
            return
        }
        return this.$router.push('/').catch(()=>{})
    },
    methods: {
        moment,
        getData: function() {
            db.collection('CpRequests')
                .orderBy('created_date','desc')
                .get()
                .then(response => {
                    this.response = response.docs.map(
                        doc => {
                            return {
                                ...doc.data()
                            }
                        }
                    )
                })
                 
        },
    },
    filters: {
        formatDate: (seconds) => moment.unix(seconds).format('DD/MM/YYYY'),
    }
}
</script>

<style>
th {
    padding-top: 10px;
    padding-bottom: 10px;
    text-align: center;
}
td {
    padding-left: 10px;
    padding-right: 10px;
    vertical-align: middle;
}
</style>